import { api } from "./index";
import {
  Agreement,
  AgreementCreateRequest,
  AgreementStructure,
  AgreementStudentHistoryView,
  AgreementUpdateRequest,
  AgreementView
} from "../../shared/types/agreement";
import { PageRequest, PageResponse } from "../../shared/types/page";

export const getAllAgreementsFetch = async (
    pageRequest: PageRequest
): Promise<PageResponse<AgreementView>> => {
    const response = await api.post<PageResponse<AgreementView>>(
        `/views/agreements/paginate`,
        pageRequest
    );
    return response.data;
};

export const createAgreementFetch = async (request: AgreementCreateRequest): Promise<AgreementStructure> => {
    const response = await api.post<AgreementStructure>(
        `/structure/agreements`,
        request
    );
    return response.data;
};

export const updateAgreementFetch = async (
    id: number,
    request: AgreementUpdateRequest
): Promise<AgreementStructure> => {
    const response = await api.patch<AgreementStructure>(
        `/structure/agreements/${id}`,
        request
    );
    return response.data;
};

export const switchAgreementEnabledFetch = async (id: number): Promise<Agreement> => {
    const response = await api.post<Agreement>(
        `/agreements/${id}/switch/enabled`
    );
    return response.data;
};

export const loadAgreementByIdFetch = async (id: number): Promise<AgreementStructure> => {
    const response = await api.get<AgreementStructure>(
        `/structure/agreements/${id}`
    );
    return response.data;
};

export const getAllAgreementStudentHistoriesFetch = async (
    pageRequest: PageRequest
): Promise<PageResponse<AgreementStudentHistoryView>> => {
    const response = await api.post<PageResponse<AgreementStudentHistoryView>>(
        `/views/agreement-student-histories/paginate`,
        pageRequest
    );
    return response.data;
}; 